<div *transloco="let t; read: 'point-popout'" class="point-popout__container">
  <button
    [disabled]="isDashboardLocked"
    [matTooltip]="t('dashboard-locked')"
    appShowMatTooltipIfDisabled
    class="point-popout__item"
    (click)="onSmartSummary()"
  >
    <xi-icon icon="lightbulb"></xi-icon>

    <span>{{ t('smart-summary') }}</span>
  </button>
</div>
